module.exports = __webpack_public_path__ + "img/unsplash_logo_full.7a3cdddb.svg";